var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_715_3366)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6296 10.8008L9.3902 20.1178C9.03171 20.483 8.60399 20.7733 8.13208 20.9713C7.66016 21.1694 7.15349 21.2714 6.64169 21.2714C6.12987 21.2714 5.62322 21.1694 5.15128 20.9713C4.67937 20.7733 4.25166 20.483 3.89318 20.1178L1.12913 17.3072C0.405554 16.5722 0 15.5823 0 14.5509C0 13.5196 0.405554 12.5296 1.12913 11.7947L10.9741 1.91865C11.2628 1.62756 11.6063 1.39652 11.9847 1.23885C12.3632 1.08118 12.7691 1 13.1791 1C13.5891 1 13.995 1.08118 14.3735 1.23885C14.7519 1.39652 15.0954 1.62756 15.3841 1.91865L16.4866 3.02116C16.7778 3.30987 17.0088 3.65337 17.1664 4.03181C17.3242 4.41026 17.4053 4.81619 17.4053 5.22618C17.4053 5.63616 17.3242 6.04209 17.1664 6.42054C17.0088 6.799 16.7778 7.14249 16.4866 7.43119L7.75973 16.1891C7.61536 16.3348 7.44362 16.4503 7.25439 16.529C7.06517 16.6079 6.86221 16.6484 6.65722 16.6484C6.45222 16.6484 6.24926 16.6079 6.06003 16.529C5.87081 16.4503 5.69905 16.3348 5.5547 16.1891L5.01121 15.6302C4.86566 15.4858 4.75015 15.314 4.67131 15.1248C4.59248 14.9356 4.55189 14.7326 4.55189 14.5276C4.55189 14.3226 4.59248 14.1197 4.67131 13.9304C4.75015 13.7412 4.86566 13.5695 5.01121 13.4251L10.8654 7.61753",
    stroke: "#87888C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_715_3366"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.1843,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.32e097383ce6a1bfb76c9056a5bbe837.svg";
export { ForwardRef as ReactComponent };